import * as React from 'react';

import './social-account.scss';

import {cs}    from "@Common/react/chain-services";
import {Load2} from "@Common/react/load2";

import {ConfirmDialog}            from '@Common/ui-components/heavy/common/design2/dialogs/confirm-dialog/confirm-dialog';
import {needsConfirmation}        from '@Common/ui-components/needs-confirmation/needs-confirmation';
import {keyed} from "@Common/react/keyed";

export const SocialAccount = (
    {
        platformLabel, icon, getAccount, removeAccount, getLoginUrl, isLoggedIn, getUserLabel, getPages = null,
    }
) => cs(
    ["account", (_, next) => Load2({fetch: getAccount, next})],
    ["values", ({account}, next) => next({
        loginUrl: getLoginUrl(account),
        userLabel: getUserLabel(account),
        isLoggedIn: isLoggedIn(account),
        pages: getPages?.(account),
    })],
    ["confirmDialog", ({}, next) => ConfirmDialog({next})],  
    ({values, confirmDialog, account}) => (
        <div className="social-box" key={platformLabel} xd-qa-type="card" xd-qa-name={platformLabel + " Section"}>
            <div className="account">
                <div className="left">
                    <div className="icon" xd-qa-type="icon" xd-qa-name={platformLabel + " Icon"}>
                        <img src={icon} className={values.isLoggedIn ? "active" : "inactive"} alt={platformLabel + " icon"}/>
                    </div>
                    <div className="text">
                        <div className="platform" xd-qa-type="label" xd-qa-name={platformLabel}>
                            {platformLabel}
                        </div>
                        {values.isLoggedIn && (
                            <div className="user" xd-qa-type="label" xd-qa-name={values.userLabel}>
                                {values.userLabel}
                            </div>
                        )}
                    </div>
                </div>
                <div className="right">
                    {values.isLoggedIn ? <>
                        {values.pages && (
                            <a
                                className="edit"
                                href={values.loginUrl}
                                xd-qa-type="link"
                                xd-qa-name={"Edit " + platformLabel}
                            >
                                Edit
                            </a>
                        )}
                        <a
                            className="disconnect"
                            onClick={async () => {
                                const proceed = await needsConfirmation({
                                    confirmDialog,
                                    actionName: "remove",
                                    message: `Remove ${platformLabel} Account`
                                })
                                if(proceed) {
                                    await removeAccount()
                                    await account?.reload()
                                    return true
                                }
                                return false;
                            }}
                            xd-qa-type="link"
                            xd-qa-name={"Remove " + platformLabel}
                        >
                            {"REMOVE"}
                        </a>
                    </> : (
                        <a
                            className={"connect"}
                            href={values.loginUrl}
                            xd-qa-type="link"
                            xd-qa-name={"Add " + platformLabel}
                        >
                            {"ADD"}
                        </a>
                    )}
                </div>
            </div>
            {values.pages && (
                <div className="pages">
                    {values.pages.map((page, i) => cs(
                        keyed(page.id),
                        () => (
                            <div
                                className="page"
                            >
                                <img src={"https://icon-library.com/images/facebook-pages-icon/facebook-pages-icon-14.jpg"} alt="fb-page" />
                                <div xd-qa-type="text" xd-qa-name={"Page " + i}>{page.name}</div>
                            </div>
                        ),
                    ))}

                </div>
            )}
        </div>
    )
);
